import { useState } from 'react';
import { Box } from '@mui/material';
import CustomTab from '../../../../common/components/tab/CustomTab';
import Loads from './loads/Loads';
import Dispatch from './dispatch/Dispatch';

const LogisticsDispatch = () => {
  const [tripMode, setTripMode] = useState<string>('loads');
  const [tabValue, setTabValue] = useState(0);

  const handleTrip = async (e: any, newValue: any) => {
    setTabValue(newValue);
    switch (newValue) {
      case 0:
        setTripMode('loads');
        break;
      case 1:
        setTripMode('dispatch');
        break;
      default:
        break;
    }
  };

  let tripList = ['Loads', 'Dispatch'];

  return (
    <Box className='logistics-mode-container'>
      <CustomTab onChange={handleTrip} value={tabValue} tabList={tripList} />
      {tripMode === 'loads' ? <Loads /> : <Dispatch />}
    </Box>
  );
};

export default LogisticsDispatch;
